import { CreateStore, createStore } from '@packages/stores';

export interface GlobalState {
  isReferralModalClosed: boolean;
  isExtraCancellationAddedByDefaultForCanstar: boolean;
}

export interface GlobalActions {
  setIsReferralModalClosed: (isReferralModalClosed: boolean) => void;
  setIsExtraCancellationAddedByDefaultForCanstar: (
    isExtraCancellationAddedByDefaultForCanstar: boolean,
  ) => void;
}

export type GlobalStore = GlobalState & GlobalActions;

const initialState: GlobalState = {
  isReferralModalClosed: false,
  isExtraCancellationAddedByDefaultForCanstar: false,
};

const globalStore: CreateStore<GlobalStore> = set => ({
  ...initialState,
  setIsReferralModalClosed(isReferralModalClosed: boolean) {
    set(state => {
      state.isReferralModalClosed = isReferralModalClosed;
    });
  },
  setIsExtraCancellationAddedByDefaultForCanstar(
    isExtraCancellationAddedByDefaultForCanstar: boolean,
  ) {
    set(state => {
      state.isExtraCancellationAddedByDefaultForCanstar =
        isExtraCancellationAddedByDefaultForCanstar;
    });
  },
});

export const useGlobalStore = createStore(globalStore, {
  name: 'useGlobalStore',
});
